import { Component, ChangeEvent } from 'react';
import styled from 'styled-components';
import { Contribution } from '../../../../../../../common/model/input/contributions/types';
import { NiceButton } from '../../../../../generic/components/buttons/nice-button';
import { BouTextAreaInput } from '../../../../../generic/components/inputs/bou-text-area-input';
import { getTextStyle } from '../../../../../generic/content/texts/bou-text/text-style';
import { BouSpacingLevel, fluidSpacing } from '../../../../../generic/layout/bou-spacing';
import { ContributionModalTitle } from './common';

interface State {
  comment?: string;
  contacts?: string;
}

interface Props {
  isSubmitting: boolean;
  submitContribution: (options: { target?: string; data: Contribution }) => void;
}

export class OpenCommentForm extends Component<Props, State> {
  public state: State = {};

  public render() {
    const { isSubmitting } = this.props;
    const { comment, contacts } = this.state;

    const canSubmit = !!comment;

    return (
      <>
        <ContributionModalTitle>Contact us</ContributionModalTitle>
        <Text>
          Interested in purchasing access to the full model and tools? Or want to give feedback, or just get in touch
          with the Upright team? Feel free to send a message to us!
        </Text>
        <form
          onSubmit={e => {
            e.preventDefault();
          }}
        >
          <Row>
            <BouTextAreaInput
              placeholder={`What's on your mind?`}
              value={comment || ''}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) => this.setState({ comment: e.target.value })}
            />
          </Row>
          <Row>
            <Text>If you want us to get back to you, please share your contact details.</Text>
            <BouTextAreaInput
              placeholder={`Your name, email and/or phone (optional)`}
              value={contacts || ''}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) => this.setState({ contacts: e.target.value })}
            />
          </Row>

          <Row>
            <NiceButton
              type="submit"
              disabled={isSubmitting || !canSubmit}
              onClick={() => {
                if (this.state.comment) {
                  this.props.submitContribution({
                    data: {
                      type: 'OPEN_COMMENT',
                      comment: this.state.comment,
                      contacts: this.state.contacts,
                      location: window.location.href,
                    },
                  });
                }
              }}
            >
              Submit
            </NiceButton>
          </Row>
        </form>
      </>
    );
  }
}

const Row = styled.div`
  & + & {
    ${fluidSpacing('margin-top', BouSpacingLevel.SMALL)}
  }
`;

const Text = styled.p`
  ${getTextStyle({ size: 'xsmall', withMargin: true })}
`;
